import { render, staticRenderFns } from "./ButtonAnswer.vue?vue&type=template&id=8c02cec0"
import script from "./ButtonAnswer.vue?vue&type=script&lang=js"
export * from "./ButtonAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports